var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hero__content" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("transition", { attrs: { name: "slide" } }, [
          _vm.playbutton
            ? _c("div", { staticClass: "hero__playBtn mb-3" }, [
                _c(
                  "div",
                  {
                    staticClass: "play",
                    on: {
                      click: function($event) {
                        return _vm.$emit("clickPlayButton", $event)
                      }
                    }
                  },
                  [_c("div", { staticClass: "play__btn" })]
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.logo
          ? _c("img", {
              staticClass: "hero__logo pb-1",
              attrs: {
                src: _vm.$helpers.image(_vm.logo, "600x0_ratio"),
                alt: _vm.logo.localized.description
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.title
          ? _c("h1", { staticClass: "hero__title" }, [
              _vm._v(_vm._s(_vm.title))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.subtitle
          ? _c("h2", { staticClass: "hero__subtitle" }, [
              _vm._v(_vm._s(_vm.subtitle))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.content || _vm.$slots.default
          ? _c(
              "div",
              { staticClass: "hero__text" },
              [
                _vm.content
                  ? _c("div", {
                      directives: [
                        { name: "parse-content", rawName: "v-parse-content" }
                      ],
                      domProps: { innerHTML: _vm._s(_vm.content) }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm._t("default")
              ],
              2
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c1be18e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c1be18e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./js/components/common/HeroElements/Content.vue
// module id = 201
// module chunks = 17